import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { CommercialRoute } from "./commercial.routes";

export function Commercial() {
  return (
    <Layout>
      {CommercialRoute.subRoutes && (
        <ModuleRouter subRoutes={CommercialRoute.subRoutes} path={CommercialRoute.path} />
      )}
    </Layout>
  );
}
